import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import TravelPlanAddButton from '../../travelPlan/TravelPlanAddButton.vue'
import LButton from '@/components/core/Button.vue'
import { useContext } from '@/composables/context'
import { useTransportationStore } from '@/stores/transportation'
import { Transportation } from '@/types/transportation'
import { getDefaultEmojiForTransportationType } from '@/utils/transportation'
import { locationToAutocompleteResult } from '@/utils/location'

export interface TransportationItemProps {
  transportations: Transportation[]
  waypointId: string
  isArrivalSection?: boolean
  editMode?: boolean
  showHoverButtons?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransportationSection',
  props: {
    transportations: null,
    waypointId: null,
    isArrivalSection: { type: Boolean },
    editMode: { type: Boolean },
    showHoverButtons: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  transportations: Transportation[]
  waypointId: string
  isArrivalSection?: boolean
  editMode?: boolean
  showHoverButtons?: boolean
};



const transportationStore = useTransportationStore()

const { i18n } = useContext()

const filteredTransportations = computed(() => {
  if (!props.isArrivalSection) {
    return props.transportations.filter(
      (transportation) => !transportation.isArrivalTransportation,
    )
  } else {
    return props.transportations.filter(
      (transportation) => transportation.isArrivalTransportation,
    )
  }
})

// This is used to determine the index offset for the transportation items
// when the waypoint has arrival transportations.
const indexOffset = computed(() => {
  if (props.isArrivalSection) {
    return 0
  } else {
    return props.transportations.length - filteredTransportations.value.length
  }
})

function openTransportationSlideOver(
  params:
    | {
        index: number
      }
    | {
        transportation: Transportation
      },
) {
  if ('transportation' in params) {
    if (params.transportation.type === 'flight') {
      transportationStore.selectTransportation({
        transportation: {
          departureAirport: { iata: '' },
          arrivalAirport: { iata: '' },
          ...params.transportation,
          origin: locationToAutocompleteResult(params.transportation.origin),
          destination: locationToAutocompleteResult(
            params.transportation.destination,
          ),
        },
        waypointId: props.waypointId,
      })
    } else {
      transportationStore.selectTransportation({
        transportation: {
          ...params.transportation,
          origin: locationToAutocompleteResult(params.transportation.origin),
          destination: locationToAutocompleteResult(
            params.transportation.destination,
          ),
        },
        waypointId: props.waypointId,
      })
    }
  } else {
    transportationStore.selectTransportation({
      transportation: {
        type: 'driving',
        emoji: getDefaultEmojiForTransportationType('driving'),
        documents: [],
        rentals: [],
        isArrivalTransportation: props.isArrivalSection ?? false,
      },
      waypointId: props.waypointId,
    })
  }
}

function getTransportationDescription(transportation: Transportation) {
  return (
    transportation.title ??
    transportation.label ??
    i18n.t(`transportation.${transportation.type}.label`).toString()
  )
}

return { __sfc: true,props, transportationStore, i18n, filteredTransportations, indexOffset, openTransportationSlideOver, getTransportationDescription, TravelPlanAddButton, LButton }
}

})